import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import {
  TStatisticsPublicFilterPayload,
  TStatisticsPublicViewsCountByNavigationFilterPayload,
  TStatisticsPublicViewsCountByTimeTablePayload,
} from '../../types/statistics/statistics-public';
import { STATISTICS_PUBLIC_ACTIONS_NAME } from './name';
import { TStatisticsPublicStoreState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getPagesTable(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicViewsCountByNavigationFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getPagesTable,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getPagesTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getSectionsTable(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicViewsCountByNavigationFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getSectionsTable,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getSectionsTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getViewsCountByTimeTable(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicViewsCountByTimeTablePayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getViewsCountByTimeTable,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getViewsCountByTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getVisitsCountByTimeTable(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicViewsCountByTimeTablePayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getVisitsCountByTimeTable,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getVisitsCountByTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getVisitsCountByTimeChartData(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getVisitsCountByTimeChartData,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getVisitsCountByTimeTable),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getViewsCountByTimeChartData(
  context: ActionContext<TStatisticsPublicStoreState, unknown>,
  payload: TStatisticsPublicFilterPayload,
) {
  return request(
    context,
    {
      url: links.admin.statistics.public.getViewsCountByTimeChartData,
      name: getLocalState(STATISTICS_PUBLIC_ACTIONS_NAME.getViewsCountByTimeChartData),
      abortController: payload.abortController,
    },
    payload.params,
  );
}
